import React from 'react';
import {makeStyles} from '@mui/styles';
import {Box, Grid, Typography} from '@mui/material';
import useScreenWidth from '../../../hooks/useScreenWidth';
import {Rating} from '@mui/material';
import {theme} from '../../../Theme';
import {HelpOutline} from '@mui/icons-material';
import BidmiiTooltip from '../../../common/StyledComponents/BidmiiTooltip';

const useStyles = makeStyles(() => ({
  rating: {
    margin: '-4px 6px 0',

    // '& .MuiRating-iconEmpty': {
    //   color: 'transparent',
    // },
  },
}));

interface IProps {
  user: any;
}

export default function CompanySummary({user}: IProps) {
  const classes = useStyles();
  const width = useScreenWidth();

  return (
    <Box mt={width > 600 ? 10 : 4} mb={2}>
      <Grid container direction="column" alignItems="center">
        <Typography
          color="primary"
          style={{fontSize: width > 600 ? 54 : 24, fontWeight: 500}}>
          {user.companyName}
        </Typography>
        <Typography
          style={{fontSize: width > 600 ? 28 : 16, textTransform: 'capitalize'}}
          color="textSecondary">
          {user.title} in {user.city}, {user.province}
        </Typography>

        {user.rating > 75 && (
          <>
            <Grid
              container
              alignItems="center"
              style={{width: 'auto', marginTop: 8}}>
              <Typography style={{fontSize: width > 600 ? 20 : 16}}>
                {(user.rating / 20).toFixed(1)}
              </Typography>
              <Rating
                name="companyRating"
                defaultValue={user.rating / 20}
                precision={0.1}
                readOnly
                className={classes.rating}
                style={{
                  color: user.color || theme.palette.primary.main,
                  fontSize: width > 600 ? 26 : 22,
                }}
              />
              <Typography
                color="textSecondary"
                style={{fontSize: width > 600 ? 15 : 13}}>
                {user.noOfReviews} review
                {user.noOfReviews === 1 ? '' : 's'}
              </Typography>
            </Grid>

            <Grid container alignItems="center" style={{width: 'auto'}}>
              <img
                src={'https://cdn.bidmii.com/media/web_assets/logo.webp'}
                alt="bidmii"
                style={{width: 38}}
              />
              <Typography
                color="textSecondary"
                style={{fontSize: 13, margin: '0 4px', lineHeight: 1}}>
                verified
              </Typography>
              <BidmiiTooltip
                long
                title={
                  <p>
                    Bidmii is a platform that helps make renovations easy and
                    secure for both homeowners and contractors.
                    <br />
                    <br />
                    Bidmii verified reviews and ratings are generated exlusively
                    by confirmed paying customers.
                  </p>
                }>
                <HelpOutline
                  style={{
                    color: theme.palette.gray.medium,
                    fontSize: 18,
                  }}
                />
              </BidmiiTooltip>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
}
